import { GlnData, PartnerPoolCompanySearchMatch } from '../model/platform-request.model';

export const mockGlnData: GlnData = {
  dataSource: 'GS1',
  gln: '4304449000000',
  organizationName: 'Tobias Inc.',
  country: 'DE',
  address: 'Rua ali',
  street: 'Rua',
  streetNumber: '123',
  postalCode: '12345',
  city: 'Offenburg',
};

export const mockDataPartnerPool: PartnerPoolCompanySearchMatch[] = [
  {
    markantId: null,
    name: 'Test Organization 1',
    address: 'Teststr. 16',
    postalCode: '12344',
    city: 'Testcity',
    countryCode: 'DE',
    goldenRecord: false,
    matchScore: 0.9331514324693042,
    streetNumber: null,
    gln: '',
    commercialRegisterId: '',
    salesTaxId: null,
    taxNumber: '12313123',
  },
  {
    markantId: null,
    name: 'Test Organization 2',
    address: 'Teststr. 20',
    postalCode: '54321',
    city: 'Testcity',
    countryCode: 'DE',
    goldenRecord: false,
    matchScore: 0.92145,
    streetNumber: null,
    gln: '',
    commercialRegisterId: '',
    salesTaxId: null,
    taxNumber: '12313123',
  },
  {
    markantId: null,
    name: 'Test Organization 3',
    address: null,
    postalCode: null,
    city: null,
    countryCode: 'DE',
    goldenRecord: false,
    matchScore: 0.752,
    streetNumber: null,
    gln: '',
    commercialRegisterId: '',
    salesTaxId: null,
    taxNumber: '12313123',
  },
];

export const mockDataPartnerPoolGoldenRecord: PartnerPoolCompanySearchMatch[] = [
  {
    ...mockDataPartnerPool[0],
    goldenRecord: true,
    markantId: 'M123456',
  },
];
